<template>
    <div>
        
        <div class="chart" id="avguser" ref="chartRef" />
    </div>
</template>
  
<script>
import * as echarts from 'echarts/core';
import { GridComponent } from 'echarts/components';
import { BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([GridComponent, BarChart, CanvasRenderer]);


export default {

    components: {

    },
    props: {
        chartData: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            option: {},
            chartDom: null,
            myChart: null
        };
    },
    mounted() {
        this.chartDom = document.getElementById('avguser');
        this.myChart = echarts.init(this.chartDom);

        this.option = {
            series: [
                {
                    type: 'pie',
                    radius: ['60%', '70%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: true,
                        position: 'center',
                        formatter: `Average Users \n  \n \n ${this.chartData}`,
                        fontWeight: 'bold',
                        fontSize: '20px',
                    },



                    color: [
                        '#0EAB98',
                        '#E9E9E9'],
                    labelLine: {
                        show: false
                    },
                    data: [
                        this.chartData
                    ]
                },

            ]
        };
        this.myChart.on('click', (params) => {
            console.log(params)
            this.$emit('drilldown', { chart: 'AvgUser', value: params.name })
        })
        this.option && this.myChart.setOption(this.option);
    }
};
</script>
  
<style scoped>
.chart {
    height: 100vh;
}
</style>
  
<style>
body {
    margin: 0;
}

#avguser {
    height: 400px;
}
</style>